export function monitoringExportFallbackFilename(now: Date = new Date()): string {
  const stamp = now.toISOString().replace(/[-:]/g, '').replace('T', '-').slice(0, 15);
  return `monitoring-report-${stamp}.xlsx`;
}
